import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { allCategoriesAction, allProductMarketsAction, allProductTypesAction } from '../../../redux/actions/userActions';
import { allProductsAction } from '../../../redux/actions/productActions';
import SearchSelect from '../../../elements/OptionWithSearch';
import { useSearchParams } from 'react-router-dom';
import { TransformProductMarkets } from '../../../utils/transformProductMarkets';


const Filters = ({ page, setPage, dateFrom, dateTo }) => {


    const dispatch = useDispatch()

    const { message } = useSelector((state) => state.reservation)
    const { message: deleteMessage } = useSelector((state) => state.deleteProduct || {});


    const { categories } = useSelector(state => state.allCategories)
    const { productTypes } = useSelector(state => state.allProductTypes);
    const { user } = useSelector(state => state.verifyEmailStore);
    const { productMarkets } = useSelector(state => state.allProductMarkets);



    const [searchParams, setSearchParams] = useSearchParams();





    const [perPage, setPerPage] = useState(searchParams.get("perPage") || '20');
    const [keyword, setKeyword] = useState(searchParams.get("keyword") || '');
    const [seller_type, setSeller_type] = useState(searchParams.get("seller_type") || '');
    const [seller_id, setSeller_id] = useState(searchParams.get("seller_id") || '');
    const [productID, setProductId] = useState(searchParams.get("productID") || '');
    const [category_id, setCategory_id] = useState(searchParams.get("category_id") || '');
    const [product_type_id, setProduct_type_id] = useState(searchParams.get("product_type_id") || '');
    const [filter_count, setFilter_count] = useState(0);
    const [status, setStatus] = useState(searchParams.get("status") || '');
    const [market_id, setMarketID] = useState(searchParams.get("market_id") || "");



    useEffect(() => {
        dispatch(allCategoriesAction())
        dispatch(allProductTypesAction())
        dispatch(allProductMarketsAction())

    }, [dispatch])




    useEffect(() => {
        setPage(Number(searchParams.get("page")) || 1)

    }, [searchParams, setPage])




    useEffect(() => {

        const query = {}

        if (dateFrom) query.dateFrom = dateFrom
        if (dateTo) query.dateTo = dateTo
        if (keyword) query.keyword = keyword
        if (seller_type) query.seller_type = seller_type
        if (seller_id) query.seller_id = seller_id
        if (productID) query.productID = productID
        if (market_id) query.market_id = market_id
        if (category_id) query.category_id = category_id
        if (product_type_id) query.product_type_id = product_type_id
        if (perPage) query.perPage = perPage
        if (status) query.status = status

        query.page = page

        // ✅ update URL
        setSearchParams(query)

        // dispatch API
        dispatch(allProductsAction(query))

    }, [
        deleteMessage,
        dateFrom,
        dateTo,
        keyword,
        seller_type,
        seller_id,
        productID,
        market_id,
        category_id,
        product_type_id,
        perPage,
        page,
        dispatch,
        setSearchParams,
        status,
        message
    ])






    useEffect(() => {

        setKeyword(searchParams.get("keyword") || "")
        setSeller_type(searchParams.get("seller_type") || "")
        setProductId(searchParams.get("productID") || "")
        setMarketID(searchParams.get("market_id") || "")
        setCategory_id(searchParams.get("category_id") || "")
        setProduct_type_id(searchParams.get("product_type_id") || "")
        setPerPage(searchParams.get("perPage") || "20")
        setPage(Number(searchParams.get("page")) || 1)
        setSeller_id(searchParams.get("seller_id") || "")
        setStatus(searchParams.get("status") || "")


    }, [searchParams, setPage])




    useEffect(() => {

        setFilter_count(0)

        if (keyword) {
            setFilter_count(prev => prev + 1)
        }
        if (seller_type) {
            setFilter_count(prev => prev + 1)
        }
        if (seller_id) {
            setFilter_count(prev => prev + 1)
        }
        if (productID) {
            setFilter_count(prev => prev + 1)
        }
        if (market_id) {
            setFilter_count(prev => prev + 1)
        }
        if (category_id) {
            setFilter_count(prev => prev + 1)
        }
        if (product_type_id) {
            setFilter_count(prev => prev + 1)
        }
        if (product_type_id) {
            setFilter_count(prev => prev + 1)
        }
        if (status) {
            setFilter_count(prev => prev + 1)
        }

    }, [keyword, seller_type, seller_id, productID, market_id, category_id, product_type_id, status])



    return (
        <Fragment>
            <div className="bg-white p-[2vmax] shadow-sm rounded-xl border border-gray-100">
                <div className="flex items-center justify-between mb-[1.5vmax]">
                    <div className="flex items-center gap-[0.5vmax]">
                        <div className="w-[0.3vmax] h-[1.5vmax] bg-indigo-600 rounded-full"></div>
                        <h3 className="text-[1.4vmax] lg:text-[1.2vmax] font-bold text-gray-700">Search Filters</h3>
                    </div>
                    
                    <div className="flex items-center gap-[1vmax]">
                        <span className='text-[1.1vmax] lg:text-[0.9vmax] text-gray-500 font-medium' >Items per page:</span>
                        <div className="flex bg-gray-50 items-center border border-gray-200 p-[0.4vmax_0.8vmax] rounded-lg focus-within:border-indigo-400 transition-all">
                            <i className="fa-solid fa-list-ul text-gray-400 text-[1.1vmax] lg:text-[0.9vmax]"></i>
                            <select 
                                className="pl-[0.5vmax] text-[1.1vmax] lg:text-[0.95vmax] text-gray-600 outline-none bg-transparent cursor-pointer"
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(e.target.value)
                                    setPage(1)
                                }}
                            >
                                <option value="1">1</option>
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-[1.2vmax]">
                    {/* Keyword Search */}
                    <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                        <i className="fa-solid fa-magnifying-glass text-gray-400 text-[1.2vmax] lg:text-[1vmax]"></i>
                        <input 
                            type="text" 
                            className="w-full pl-[0.8vmax] text-[1.1vmax] lg:text-[0.95vmax] bg-transparent outline-none text-gray-700 placeholder-gray-400" 
                            placeholder="Search Keyword..."
                            value={keyword}
                            onChange={(e) => {
                                setKeyword(e.target.value)
                                setPage(1)
                            }}
                        />
                    </div>

                    {/* Chinese Seller */}
                    {user?.role !== 'PM' && (
                        <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                            <i className="fa-solid fa-user-tag text-gray-400 text-[1.2vmax] lg:text-[1vmax]"></i>
                            <input 
                                type="text" 
                                className="w-full pl-[0.8vmax] text-[1.1vmax] lg:text-[0.95vmax] bg-transparent outline-none text-gray-700 placeholder-gray-400" 
                                placeholder="Chinese Seller..."
                                value={seller_type}
                                onChange={(e) => {
                                    setSeller_type(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                    )}

                    {/* Product ID */}
                    <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                        <i className="fa-solid fa-barcode text-gray-400 text-[1.2vmax] lg:text-[1vmax]"></i>
                        <input 
                            type="text" 
                            className="w-full pl-[0.8vmax] text-[1.1vmax] lg:text-[0.95vmax] bg-transparent outline-none text-gray-700 placeholder-gray-400" 
                            placeholder="Product ID..."
                            value={productID}
                            onChange={(e) => {
                                setProductId(e.target.value)
                                setPage(1)
                            }}
                        />
                    </div>

                    {/* Seller ID */}
                    {user?.role !== 'PMM' &&
                        <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                            <i className="fa-solid fa-id-badge text-gray-400 text-[1.2vmax] lg:text-[1vmax]"></i>
                            <input 
                                type="text" 
                                className="w-full pl-[0.8vmax] text-[1.1vmax] lg:text-[0.95vmax] bg-transparent outline-none text-gray-700 placeholder-gray-400" 
                                placeholder="Seller ID..."
                                value={seller_id}
                                onChange={(e) => {
                                    setSeller_id(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                    }

                    {/* Market Select */}
                    <div className="relative flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                        <i className="fa-solid fa-earth-americas text-gray-400 text-[1vmax]"></i>
                        <SearchSelect
                            options={TransformProductMarkets(productMarkets)}
                            value={market_id}
                            onChange={setMarketID}
                            placeholder="Select Market"
                            name="market"
                            classes="w-full pl-[0.5vmax] text-[1.1vmax] lg:text-[0.95vmax] bg-transparent outline-none text-gray-700"
                        />
                    </div>

                    {/* Category Select */}
                    <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                        <i className="fa-solid fa-layer-group text-gray-400 text-[1.2vmax] lg:text-[1vmax]"></i>
                        <select 
                            className="w-full pl-[0.8vmax] text-[1.1vmax] lg:text-[0.95vmax] bg-transparent outline-none text-gray-700 cursor-pointer"
                            value={category_id}
                            onChange={(e) => {
                                setCategory_id(e.target.value)
                                setPage(1)
                            }}
                        >
                            <option value="">All Categories</option>
                            {categories && categories.map((category) =>
                                category.is_active === 1 &&
                                <option key={category.id} value={category.id}>{category.name}</option>
                            )}
                        </select>
                    </div>

                    {/* Product Type Select */}
                    <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                        <i className="fa-solid fa-tags text-gray-400 text-[1.2vmax] lg:text-[1vmax]"></i>
                        <select 
                            className="w-full pl-[0.8vmax] text-[1.1vmax] lg:text-[0.95vmax] bg-transparent outline-none text-gray-700 cursor-pointer"
                            value={product_type_id}
                            onChange={(e) => {
                                setProduct_type_id(e.target.value)
                                setPage(1)
                            }}
                        >
                            <option value="">All Product Types</option>
                            {productTypes && productTypes.map((productType) =>
                                productType.is_active === 1 &&
                                <option key={productType.id} value={productType.id}>{productType.name}</option>
                            )}
                        </select>
                    </div>

                    {/* Status Select */}
                    {user?.role !== "PM" &&
                        <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                            <i className="fa-solid fa-circle-check text-gray-400 text-[1.2vmax] lg:text-[1vmax]"></i>
                            <select 
                                className="w-full pl-[0.8vmax] text-[1.1vmax] lg:text-[0.95vmax] bg-transparent outline-none text-gray-700 cursor-pointer"
                                value={status}
                                onChange={(e) => {
                                    setStatus(e.target.value)
                                    setPage(1)
                                }}
                            >
                                <option value="">Product Status</option>
                                <option value="ACTIVE">Active</option>
                                <option value="COMPLETED">Completed</option>
                                <option value="INACTIVE">Inactive</option>
                                <option value="PAUSED">Paused</option>
                                <option value="SUSPENDED">Suspended</option>
                                <option value="SYSTEM_CANCELLED">System Cancelled</option>
                            </select>
                        </div>
                    }

                    {/* Clear Filters Button */}
                    {filter_count > 0 &&
                        <div className="flex items-center justify-end lg:col-span-1 xl:col-span-1">
                            <button 
                                className="w-full flex items-center justify-center gap-[0.5vmax] bg-red-50 text-red-600 py-[0.7vmax] px-[1.5vmax] rounded-xl hover:bg-red-600 hover:text-white transition-all duration-300 font-bold shadow-sm border border-red-100"
                                onClick={() => {
                                    setKeyword("")
                                    setSeller_type("")
                                    setSeller_id("")
                                    setProductId("")
                                    setMarketID("")
                                    setCategory_id("")
                                    setProduct_type_id("")
                                    setStatus("")
                                    setPage(1)
                                }}
                            >
                                <i className="fa-regular fa-trash-can text-[1.2vmax] lg:text-[1vmax]"></i>
                                Clear All
                            </button>
                        </div>
                    }
                </div>
            </div>

        </Fragment>
    )
}

export default Filters
